import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { find } from 'lodash';

const selectLocale = (state: RootState) => state.ui.locale;
const selectSettings = (state: RootState) => state.site.settings;

export const selectGlobalConstants = createSelector(
  [selectLocale, selectSettings],
  (locale, settings) => find(settings, { locale })?.constants || {}
);
